import { call, put, takeLatest } from "redux-saga/effects"
import { GET_DATA_DIVISIONS_RATE_WATCHER } from "./constants"

import {
  getDataDivisionsRateSuccess,
  getDataDivisionsRateFailed,
} from "./actions"
import { getDivisionRateApi } from "../../../../../utils/routes/routes-report"

export function* getDataDivisionsRateSaga(action) {
  try {
    const dataStatus = action.payload
    const { data: divisionsRate } = yield call(
      getDivisionRateApi,
      dataStatus.params
    )
    yield put(getDataDivisionsRateSuccess(divisionsRate))
  } catch (e) {
    yield put(getDataDivisionsRateFailed())
  }
}

// Individual exports for testing
export default function* widgetResponseRateReportSaga() {
  yield takeLatest(GET_DATA_DIVISIONS_RATE_WATCHER, getDataDivisionsRateSaga)
}
